import ContentActionTypes from "./actionTypes";
import BaseActions from "../../base/BaseActions";

const ContentActions = {
  ...BaseActions("content", ContentActionTypes),
};
export default ContentActions;
